var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"divider",class:_vm.type == 'horizontal' ? 'divider-horizontal' : 'divider-vertical'})
}
var staticRenderFns = []

export { render, staticRenderFns }